module.exports = __webpack_public_path__ + "img/whatson.ba930a61.png";